import {connect} from 'react-redux';
import SignUpComponent from '../../Components/Auth/SignUp';
import {userRegister} from '../../redux/actions/AuthActions';

const SignupContainer = connect (
    (state) => {
        return {
            signup: state.authReducer
        };
    },
    (dispatch) => {
        return {
            userRegister: (userData) => {
                dispatch(userRegister(userData));
            }
        };
    }
)(SignUpComponent);

export default SignupContainer;